import { IconBrain, IconTarget, IconBolt, IconSunrise, IconBell, IconBook, IconMoon, IconDeviceMobile, IconMoonStars } from "@tabler/icons-react";
import { useEffect, useState } from "react";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

const PainPoints = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prev) => (prev + 1) % painPoints.length);
    }, 1500);
    return () => clearInterval(interval);
  }, []);

  const painPoints = [
    {
      descriptionKey: "painPoints.points.morning",
      icon: IconSunrise,
    },
    // {
    //   descriptionKey: "painPoints.points.notification",
    //   icon: IconBell,
    // },
    {
      descriptionKey: "painPoints.points.reading",
      icon: IconBook,
    },
    {
      descriptionKey: "painPoints.points.relax",
      icon: IconMoonStars,
    },
    // {
    //   descriptionKey: "painPoints.points.toilet",
    //   icon: IconDeviceMobile,
    // },
    {
      descriptionKey: "painPoints.points.boredom",
      icon: IconDeviceMobile,
    },
    {
      descriptionKey: "painPoints.points.uninstall",
      icon: IconDeviceMobile,
    },
  ];

  const reasons = [
    {
      titleKey: "painPoints.context.reasons.infoAnxiety.title",
      descriptionKey: "painPoints.context.reasons.infoAnxiety.description",
      icon: IconBrain,
    },
    {
      titleKey: "painPoints.context.reasons.socialAnxiety.title",
      descriptionKey: "painPoints.context.reasons.socialAnxiety.description",
      icon: IconTarget,
    },
    {
      titleKey: "painPoints.context.reasons.sleepProcrastination.title",
      descriptionKey: "painPoints.context.reasons.sleepProcrastination.description",
      icon: IconBolt,
    },
  ];

  return (
    <section className="pt-8 pb-4 bg-slate-50">
      <div className="max-w-7xl mx-auto px-0 sm:px-2 lg:px-4">
        <div className="bg-sky-950 px-5 md:px-8 pt-8 pb-8 md:pb-10 sm:rounded-xl border border-sky-300">
          <div className="text-center mb-8 mx-auto max-w-2xl px-8 md:px-0">
            <h2 className="text-2xl md:text-4xl font-semibold text-white mb-4 md:mb-8 leading-snug md:leading-snug">
              {t('painPoints.title')}
            </h2>
          </div>

          <div className="max-w-3xl mx-auto space-y-2.5 md:space-y-4">
            {painPoints.map((painPoint, index) => (
              <div
                key={index}
                className={`flex justify-center`}
              >
                <div
                  className={cn(
                    "relative flex items-start max-w-lg shadow-lg rounded-xl px-6 md:px-8 pt-3 pb-3.5 transition-all duration-300 ease-in-out",
                    "before:top-[16px] before:border-y-[10px] before:border-transparent before:absolute",
                    "bg-slate-100",
                    index === activeIndex ? "bg-yellow-300 text-slate-800 opacity-100" : "text-slate-400 opacity-70",
                    index % 2 === 0
                      ? 'before:left-[-9px] before:border-r-[10px] before:border-l-0 before:border-r-slate-100'
                      : 'before:right-[-9px] before:border-l-[10px] before:border-r-0 before:border-l-slate-100',
                  )}
                >
                  <div className={cn(
                    "absolute inset-0 bg-yellow-300 rounded-xl opacity-0 transition-opacity duration-300 ease-in-out",
                    "before:top-[16px] before:border-y-[10px] before:border-transparent before:absolute",
                    index % 2 === 0
                      ? 'before:left-[-10px] before:border-r-[10px] before:border-l-0 before:border-r-yellow-300'
                      : 'before:right-[-10px] before:border-l-[10px] before:border-r-0 before:border-l-yellow-300'
                  )}
                    style={{ opacity: index === activeIndex ? 1 : 0 }}
                  />
                  <div className={`flex gap-4 md:gap-5 items-center relative`}>
                    {/* <div className="flex-shrink-0">
                      <painPoint.icon className={cn("w-6 h-6", index === activeIndex ? "text-yellow-950" : "text-slate-500")} />
                    </div>
                    <div className="w-[1px] h-6 bg-current opacity-30"></div> */}
                    <p className="leading-relaxed text-base font-medium md:text-lg">
                      {t(painPoint.descriptionKey)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mb-8 mt-16 mx-auto max-w-2xl px-4">
          <div className="text-lg md:text-2xl mb-2 mx-12 md:mx-0">{t('painPoints.context.intro')}</div>
          <h2 className="text-2xl md:text-4xl font-semibold text-sky-500 mb-4 md:mb-8 leading-snug md:leading-snug px-8 md:px-0">
            {t('painPoints.context.title')}
          </h2>
          {
            (t('painPoints.context.descriptions', { returnObjects: true }) as string[]).map((description, index) => (
              <p key={index} className="text-left text-slate-600 leading-relaxed text-base md:text-lg mb-6 mx-2">{description}</p>
            ))
          }
        </div>

        <div className="bg-white border border-slate-200 rounded-xl mx-4">
          <div className="grid grid-cols-1 md:grid-cols-3 divide-y md:divide-y-0 md:divide-x divide-slate-200">
            {reasons.map((reason, index) => (
              <div
                key={index}
                className="px-6 pt-5 md:pt-8 pb-7 flex flex-row md:flex-col items-center gap-4"
              >
                <div className="mb-0 md:mb-2 w-12 h-12 md:w-16 md:h-16 bg-sky-500 rounded-full flex items-center justify-center shrink-0">
                  <reason.icon className="w-8 h-8 text-white" />
                </div>
                <div className="flex flex-col items-start md:items-center gap-1 md:gap-3">
                  <h3 className="text-slate-900 leading-relaxed text-lg md:text-2xl text-left font-semibold">
                    {t(reason.titleKey)}
                  </h3>
                  <p className="text-sm md:text-base text-slate-600 text-left mx-auto leading-relaxed md:leading-relaxed">
                    {t(reason.descriptionKey)}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="text-center mx-auto max-w-xl">
          <div className="space-y-8 text-lg md:text-2xl text-slate-900 mb-0 mt-12 md:mb-0 leading-normal md:leading-snug px-8">
            {(t('painPoints.context.conclusion', { returnObjects: true }) as string[]).map((text, index) => (
              <p key={index}>{text}</p>
            ))}
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default PainPoints;
